import { reactionKeys } from './constants'

import { createEventEmitter } from '../event'

export const reactionEventEmitter = createEventEmitter()

export const emitShowReactionMsg = msg => {
    reactionEventEmitter.emit(reactionKeys.SHOW_REACTION, msg)
}

export const emitShowGiphyMsg = msg => {
    reactionEventEmitter.emit(reactionKeys.SHOW_GIPHY, msg)
}

export const emitTriggerGiphyModal = value => {
    reactionEventEmitter.emit(reactionKeys.TRIGGER_GIPHY_MODAL, value)
}
